module.exports = __webpack_public_path__ + "img/waiting in comfort.873e9ba1.png";